import {COIN_PAYMENT_KEY, DPP_CHECKOUT_TEMPLATES, QR_VIEW_EVENTS, PAYMENT_WALL_KEY, IOS_CHECKOUT_TEMPLATES, OS_MAC, OS_WINDOWS, PLG_CHECKOUT_TEMPLATES, WINDOWS_IOS_CHECKOUT_TEMPLATES, RECURLY_DPP_V1_TEMPLATE} from '../../constants/common';
import {
  toggleLoader,
  getTranslation,
  getCookie,
  signupFormHandling,
  getPlanBillingCycle,
  getInputValue,
  handlePromise,
  showErrorMessagePopup,
  sendGaCheckoutSuccessEvent,
  sendGa4CustomEvent,
  sendGaCustomEvent,
  sendGaCheckoutFailureEvent,
  appEventHandler,
  delayFunction,
  appCheckoutFailureHandler,
  getOSDetect
} from '../../lib';
import { openCustomModal, closeCustomPopup } from '../../lib/index';
import store from '../../store';

export default class PaymentGatewayProcessor {
  static apiCalled = false;

  constructor() {
    this.state = store.state.cartState ? store.state.cartState : {};
    this.checkoutInit = this.checkoutInit;
  }

  processCheckout() {
    return this.checkoutInit();
  }

  checkoutInit() {
    return new Promise(async (resolve, reject) => {

      $(".custom-model-main3").addClass('model-open');

      var response;
      try {
        const {
          captcha_v3_enabled: captchaV3Enabled,
          skip_captcha_v3: skipCaptchaV3,
          captcha_v2_enabled: captchaV2Enabled,
          acceptable_score: acceptableScore,
        } = this.state;

        if (captchaV3Enabled !== '0' && !skipCaptchaV3) {
          /* Handle captcha v3 */
          const [token, validateCaptchaV3Err] = await handlePromise(this.validateCaptchaV3());
          if (validateCaptchaV3Err) throw validateCaptchaV3Err;

          sendGaCustomEvent('Order Cart', 'captcha_v3_trigger', `threshold: ${acceptableScore}`);

          const [checkoutApiCallRes, checkoutApiCallErr] = await handlePromise(this.checkoutApiCall({ captchaV3Token: token }));
          if (checkoutApiCallErr) throw checkoutApiCallErr;
          response = checkoutApiCallRes;
        } else if (captchaV2Enabled !== '0') {
          /* Handle captcha v2 */
          const [token, validateCaptchaV2Err] = await handlePromise(this.validateCaptchaV2());
          if (validateCaptchaV2Err) throw validateCaptchaV2Err;

          const [checkoutApiCallRes, checkoutApiCallErr] = await handlePromise(this.checkoutApiCall({ captchaV2Token: token }));
          if (checkoutApiCallErr) throw checkoutApiCallErr;
          response = checkoutApiCallRes;

        } else {
          /* Direct checkout without captcha */
          const [checkoutApiCallRes, checkoutApiCallErr] = await handlePromise(this.checkoutApiCall());
          if (checkoutApiCallErr) throw checkoutApiCallErr;
          response = checkoutApiCallRes;
        }
      } catch (err) {
        reject(err);
        // appCheckoutFailureHandler(cartState?.template_name);
      }
      resolve(response);
    });
  }

  checkoutApiCall(params = {}) {
    return new Promise(async (resolve, reject) => {
      const isPLGCheckoutTemplate = PLG_CHECKOUT_TEMPLATES.includes(cartState?.template_name);
      const isIOSCheckoutTemplate = IOS_CHECKOUT_TEMPLATES.includes(cartState?.template_name);
      const isDppCheckoutTemplate = DPP_CHECKOUT_TEMPLATES.includes(cartState?.template_name);

        const isWindowsApp = WINDOWS_IOS_CHECKOUT_TEMPLATES.includes(cartState?.template_name) && getOSDetect() === OS_WINDOWS;
        const isMacApp = WINDOWS_IOS_CHECKOUT_TEMPLATES.includes(cartState?.template_name) && getOSDetect() === OS_MAC;

      const { captchaV3Token = '', captchaV2Token = '', threeDsTokenId = '' } = params;

      let urlParams = new URLSearchParams(window.location.search);
      let referrerUuid = urlParams.get('referrer');

      const {
        selected_plan: selectedPlan,
        selected_package_index: selectedPackageIndex,
        coupon_code: couponCode,
        locale,
        selected_gateway: selectedGateway,
        rule_id: ruleId,
        selected_addons: selectedAddons,
        addon_country: addonCountry,
        addon_country3: addonCountry3,
        addon_city: addonCity,
        user_country: userCountry,
        gateway_incentive_promo_code: gatewayIncentivePromoCode,
        acquisition_channel: acquisitionChannel,
        proplan_code: proplanCode,
        device_request_id: deviceRequestID,
        teamQuantity,
        dedicatedIpsQuantity,
        portFowardingQuantity,
        multiLoginQuantity,
        residentialNetworknBandwidthQuantity,
      } = this.state;

      let requestPayload = {
        template: cartState.template_name,
        plan_code: selectedPlan.override_code || proplanCode || selectedPlan.code,
        billing_cycle: getPlanBillingCycle(),
        email: getInputValue('#input_email'),
        name: getInputValue('#input_name'),
        password: getInputValue('#input_password'),
        recurly_token: getInputValue('#recurly_token'),
        selected_option: selectedPackageIndex,
        coupon: couponCode || '',
        fpdr: cartState?.conversionDriverToggle ? '' : (selectedPlan.pre_applied_promo_code || selectedPlan.incentive_promo_code || gatewayIncentivePromoCode || ''),
        locale: locale,
        payment_method: selectedGateway,
        rule_id: ruleId,
        addons: selectedAddons ? selectedAddons.toString() : '',
        addon_country: addonCountry ?? '',
        addon_country3: addonCountry3 ?? '',
        addon_city: addonCity ?? '',
        three_ds_token_id: threeDsTokenId,
        captcha_v3_token: captchaV3Token,
        captcha_v2_token: captchaV2Token,
        device_request_id: deviceRequestID,
        country: userCountry,
        total_amount: window.total_price,
        'acquisition_channel': acquisitionChannel,
        'referrer': referrerUuid ? referrerUuid : '',
        'checkout_start_time': new Date().getTime(),
        'passwordless': !!getCookie('fa_token') ? true : !!getCookie('cart_info'),
        'currency': cartState.currency_code,
        teamQuantity: teamQuantity ?? 1,
        dedicatedIpsQuantity: dedicatedIpsQuantity ?? 1,
        portFowardingQuantity: portFowardingQuantity ?? 1,
        multiLoginQuantity: multiLoginQuantity ?? '',
        residentialNetworknBandwidthQuantity: residentialNetworknBandwidthQuantity ?? '',
        // Links this purchase back to the DPP breach scan it came from (member-area sync).
        scan_email: isDppCheckoutTemplate ? getInputValue('#input_scan_email') : '',
        sync_email_id: isDppCheckoutTemplate ? getInputValue('#input_sync_email_id') : '',
      };

      let reason = '';
      let errorCode = '';

      try {

        let formData = new FormData();
        for (const field in requestPayload) {
          let key = field;
          let value = requestPayload[field];
          formData.append(key, value);
        }

        if (!PaymentGatewayProcessor.apiCalled){
          PaymentGatewayProcessor.apiCalled = true;
          const response = await fetch(`${base_url}/wp-json/recurly/v1/checkout`, {
            method: 'POST',
            body: formData,
          });

          //rest the flag after getting response of request
          PaymentGatewayProcessor.apiCalled = false;

          let responseData = await response.json();

          if (!responseData.status) {
            const [checkoutApiCallRes, checkoutApiCallErr] = await handlePromise(this.checkoutApiCallFail(responseData));
            if(checkoutApiCallRes) responseData = checkoutApiCallRes;

          reason = responseData?.message;
          errorCode = responseData?.error_code;

          if (checkoutApiCallErr) throw checkoutApiCallErr;

          }

        sendGaCheckoutSuccessEvent();
        sendGa4CustomEvent('event_sign_up', {parameters : {}});
        if (responseData.status) {
          if (typeof window.gr === 'function' && responseData?.ids) {
            console.log('Track conversion', responseData.ids);
            const ids = JSON.parse(responseData.ids);
            gr('track', 'conversion', {
              email: ids[0] || '',
              uid: ids[1] || '',
            });
          }

          if(isPLGCheckoutTemplate || isWindowsApp){
            const response = 'Desktop app, I expect a response!';
            const message = "windows_payment_successfully_completed";

              appEventHandler(message, response);

              $(".custom-model-main3").removeClass('model-open');
              $(".custom-model-main").addClass('model-open');
            }

          if(isIOSCheckoutTemplate){
            const response = 'iOS app, I expect a response!';
            const message = "ios_web_checkout_success";

            appEventHandler(message, response, {
                payment_method: requestPayload.payment_method,
                plan_code: requestPayload.plan_code,
              }
            );

            // $(".custom-model-main").addClass('model-open');
          }

          if(isMacApp){
            const response = 'Mac app, I expect a response!';
            const message = "mac_web_checkout_success";

            appEventHandler(message, response, {
                payment_method: requestPayload.payment_method,
                plan_code: requestPayload.plan_code,
              }
            );
          }


          // Browser pixel conversion events (Purchase / Trial / Lead). The server only sends conversion_events for the
          // events picked in the checkout post's ACF field "Conversion Events" (capi_events_for_page), with the same
          // event names and event IDs, so each platform dedupes these against the server-side CAPI events.
          if (responseData.conversion_events) {
            try {
              const { value, events = [] } = JSON.parse(responseData.conversion_events);
              const currency = requestPayload.currency || 'USD';
              const metaStandard = ['Purchase', 'StartTrial', 'Lead', 'Subscribe', 'CompleteRegistration'];
              const rdtNames = { PURCHASE: 'Purchase', SIGN_UP: 'SignUp', LEAD: 'Lead' };
              events.forEach((ev) => {
                if (window.fbq && ev.meta_event_name) {
                  window.fbq(
                    metaStandard.includes(ev.meta_event_name) ? 'track' : 'trackCustom',
                    ev.meta_event_name,
                    { value, currency },
                    { eventID: ev.event_id }
                  );
                }
                if (window.rdt && ev.reddit_event_name) {
                  const rdtParams = { value, currency, itemCount: 1, conversionId: ev.event_id };
                  if (rdtNames[ev.reddit_event_name]) {
                    window.rdt('track', rdtNames[ev.reddit_event_name], rdtParams);
                  } else {
                    window.rdt('track', 'Custom', { ...rdtParams, customEventName: ev.reddit_event_name });
                  }
                }
                if (window.twq && ev.x_event_id) {
                  window.twq('event', ev.x_event_id, { value, currency, conversion_id: ev.event_id });
                }
              });
            } catch (_) {}
          }

          // Paymentwall / Coinpayment keep the normal redirect/form flow; every other DPP gateway shows the QR.
          const isRedirectGateway = [PAYMENT_WALL_KEY, COIN_PAYMENT_KEY].includes(requestPayload.payment_method);

          if (isDppCheckoutTemplate && !isRedirectGateway) {
            document.getElementById('pro-cart')?.style.setProperty('display', 'none');
            document.getElementById('order_review')?.style.setProperty('display', 'none');
            // Re-parent to <body>: a transformed ancestor (e.g. landing page sliders) would otherwise break its position:fixed
            const qrSection = document.getElementById('dpp-thankyou-qr');
            if (qrSection) {
              document.body.appendChild(qrSection);
              qrSection.style.setProperty('display', 'block');
            }
            document.documentElement.style.setProperty('overflow', 'hidden');
            document.body.style.setProperty('overflow', 'hidden');
            window.scrollTo(0, 0);

            sendGa4CustomEvent(QR_VIEW_EVENTS[cartState?.template_name], {plan_code: requestPayload.plan_code});

            if (cartState?.template_name === RECURLY_DPP_V1_TEMPLATE) {
              try {
                const ids = JSON.parse(responseData.ids || '[]');
                sendGa4CustomEvent('signup_email_push', {email: requestPayload.email});
                sendGa4CustomEvent('event_purchase', {
                  parameters: {
                    transaction_id: ids[0] || '',
                    value:          requestPayload.total_amount,
                    currency:       requestPayload.currency || 'USD',
                    coupon:         requestPayload.coupon || '',
                    payment_type:   requestPayload.payment_method,
                    items: JSON.stringify([{
                      item_id:   requestPayload.plan_code,
                      item_name: selectedPlan.name || requestPayload.plan_code,
                      quantity:  1,
                      price:     requestPayload.total_amount,
                    }]),
                  },
                });
              } catch (_) {}
            }

          } else if (responseData.code === 'form') {
            var form = document.createElement("form");
            var postData = JSON.parse(responseData.data);
            form.setAttribute("method", "post");
            form.setAttribute("action", responseData.url);
            for (var key in postData) {
              if (postData.hasOwnProperty(key)) {
                var input = document.createElement("input");
                input.setAttribute("type", "hidden");
                input.setAttribute("name", key);
                input.setAttribute("value", postData[key]);
                form.appendChild(input);
              }
            }
            document.body.appendChild(form);
            form.submit();
          }else if (responseData.code === 'redirect') {
            window.location = responseData.url;
          }

          }
          resolve(responseData);
        }else {
          resolve('Previous request is in progress..');
        }
      } catch (err) {
        reject(err);
        appCheckoutFailureHandler(cartState?.template_name, {
          payment_method: requestPayload.payment_method,
          plan_code: requestPayload.plan_code,
          reason: reason || '',
          error_code: errorCode || '',
        });
      }finally {
        //rest the flag after completion of request
        PaymentGatewayProcessor.apiCalled = false;
      }
    });
  }

  checkoutApiCallFail(res) {
    return new Promise(async (resolve, reject) => {
      let response;
      try {
        const { error_code, errors, message } = res;
        const { captcha_v2_enabled: captchaV2Enabled } = this.state;
        let errorsArr = ['checkout_exception', 'recurly_exception'];
        if (errorsArr.includes(res.error_code) && getCookie('cart_info')) {
          signupFormHandling('hide');
        }
        switch (error_code) {
          case 'three_d_secure_exception':
            // resumeCaptchaV3Verification();
            this.threeDSecureValidation(errors.three_ds_token_id);
            break;
          case 'validation_exception':
            // Show first error message only
            if (!errors.length && message) reject(message);
            let firstIndex = Object.keys(errors)[0];
            reject({ message: errors[firstIndex][0] });
            break;
          case 'captcha_v3_exception':
            sendGaCustomEvent('Order Cart', 'captcha_v3_failed', JSON.stringify(errors));
            if (captchaV2Enabled !== '0') {
              const [token, validateCaptchaV2Err] = await handlePromise(this.validateCaptchaV2());
              if (validateCaptchaV2Err) throw validateCaptchaV2Err;

              const [checkoutApiCallRes, checkoutApiCallErr] = await handlePromise(this.checkoutApiCall({ captchaV2Token: token }));
              if (checkoutApiCallErr) throw checkoutApiCallErr;
              response = checkoutApiCallRes;

            } else {
              reject({ message });
            }
            break;
          case 'team_message_exception':
              this.showTeamsMessagePopup(message);
              reject({ message });
            break;
          case 'checkout_exception':
            reject({ message });
            break;
          case 'captcha_v2_exception':
            sendGaCustomEvent('Order Cart', 'captcha_v2_failed', JSON.stringify(errors));
            reject({ message });
            break;
          default:
            reject(error_code);
        }
      } catch (err) {
        reject(err);
        // appCheckoutFailureHandler(cartState?.template_name);
      }

      resolve(response);
    });
  }

  validateCaptchaV3() {
    const { recaptcha_v3_site_key: recaptchav3siteKey } = this.state;
    return grecaptcha.execute(recaptchav3siteKey, {
      action: 'validate_captcha',
    });
  }

  validateCaptchaV2() {

    return new Promise(async (resolve, reject) => {
      const { recaptcha_v2_site_key, errors } = this.state;

      const modalCaptchaContent = `
      <div class="custom-modal">
        <div class="modal-body">
          <div id="g-recaptcha"></div>
        </div>
      </div>`;

      function openCaptchaModal() {
        grecaptcha.render('g-recaptcha', {
          sitekey: recaptcha_v2_site_key,
          callback: async token => {
            sendGaCustomEvent('Order Cart', 'captcha_v2_submitted', '');
            closeCustomPopup();
            resolve(token);
          },
        });
        sendGaCustomEvent('Order Cart', 'captcha_v2_visible', '');
      }

      openCustomModal(modalCaptchaContent, 'captchaModalId', 'captchaModalClass', '400px', true, true);

      let captchaId = document.getElementById('captchaModalId');

      if (captchaId) {
        openCaptchaModal();
        if (grecaptcha.getResponse().length === 0) {
          return `<p>${errors.captcha_v2_error}</p>`;
        }
      }

      if (!openCustomModal) {
        toggleLoader(false);
      }
    })
  }

  threeDSecureValidation(threeDsTokenId) {
    const risk = recurly.Risk();
    const threeDSecure = risk.ThreeDSecure({
      actionTokenId: threeDsTokenId,
    });

    threeDSecure.on('token', token => {
      this.checkoutApiCall({ threeDsTokenId: token.id });
      threeDSecure.remove();
    });

    threeDSecure.on('error', error => {
      toggleLoader(false);
      showErrorMessagePopup({ errorMessage: error.message });
      sendGaCheckoutFailureEvent(error.message);
      threeDSecure.remove();
    });

    threeDSecure.attach(document.querySelector('#three-ds-container'));
  }

  showTeamsMessagePopup(msg){
      toggleLoader(false);
      sendGaCheckoutFailureEvent(msg.split('.')[0]);
      showErrorMessagePopup({
          errorHeading: 'Heads Up!',
          errorMessage: msg,
          showCta: false,
          showDomMsg: false
      })
  }
}
